import { Component, Input } from '@angular/core';
import type { JssNavItem } from '@core/jss-models';
import { Setting } from '@core/settings';
import type { LinkField } from '@sitecore-jss/sitecore-jss-angular';
import { GenericLinkDirective } from '@core/jss-utils';
import { TrackLinkDirective } from '@analytics/events';
import { CSCaptureDirective } from '@legacy/utils-contentsquare';
import {
  NgbDropdown,
  NgbDropdownToggle,
  NgbDropdownMenu,
} from '@ng-bootstrap/ng-bootstrap';
import { AutomationIdDirective } from '@innogy/utils-automation-id';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';

import { HeaderToolsContainerComponent } from '../../shared/header-tools-container/header-tools-container.component';
import { NavigationServiceButtonComponent } from '@core/navigation-ui/navigation-service-button';

@Component({
  selector: 'wl-top-navigation',
  templateUrl: './top-navigation.component.html',
  styleUrls: [
    './top-navigation.component.essent.scss',
    './top-navigation.component.ed.scss',
  ],
  standalone: true,
  imports: [
    GenericLinkDirective,
    TrackLinkDirective,
    CSCaptureDirective,
    NgbDropdown,
    AutomationIdDirective,
    NgbDropdownToggle,
    FaIconComponent,
    NgbDropdownMenu,
    HeaderToolsContainerComponent,
    NavigationServiceButtonComponent,
  ],
})
export class TopNavigationComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() navItems?: JssNavItem[];

  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() openNavigation?: Setting<LinkField>;

  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() serviceNavigationTitle?: string;

  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() serviceNavigationLink?: Setting<LinkField>;

  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() serviceNavigationActive?: boolean;

  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() isLoggedIn?: boolean;

  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() loginUrl?: string;

  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() loginUrlLabel?: string;
}
